import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { CheckIcon, CancelIcon } from 'images'

// Per-location Google/Meta inclusion pills — Figma's "City, region or
// country" modal (node 31394:17254) shows one shared location list per TC
// with each row independently checkable per platform, rather than separate
// per-platform location lists.
export default function PlatformTags({ platforms, availablePlatforms, onToggle, disabled = false }) {
  const { t } = useTranslation()

  return (
    <div className="range-locations_summary__location-platform-tags">
      {availablePlatforms.map((platform) => {
        const on = !!platforms?.[platform]
        return (
          <span
            key={platform}
            role="button"
            tabIndex={disabled ? -1 : 0}
            title={t(`Recommendations.geoTargeting.rangeLocations.platformTags.${platform}`)}
            className={cn('range-locations_summary__location-platform-tag')}
            onClick={() => !disabled && onToggle(platform)}
            onKeyDown={(e) => {
              if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault()
                onToggle(platform)
              }
            }}
          >
            {on ? <CheckIcon width={12} height={12} /> : <CancelIcon width={10} height={10} />}{' '}
            <span>{t(`Recommendations.geoTargeting.rangeLocations.platformTags.${platform}`)}</span>
          </span>
        )
      })}
    </div>
  )
}

PlatformTags.propTypes = {
  platforms: PropTypes.shape({ fb: PropTypes.bool, google: PropTypes.bool }),
  availablePlatforms: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}
